namespace $.$$ {

	$mol_style_define( $bog_vmap_app_palette_port, {

		Body: {
			font: { family: 'monospace', size: '.8rem' },
			whiteSpace: 'pre-wrap',
		},

	} )

}
